import React from "react";
import BlogThirteen from "../component/BlogThirteen";

function BlogThirteenContainer() {
  return <BlogThirteen />;
}
export default BlogThirteenContainer;
